<style xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    .bottom_btn_custom{
        display: inline;
        padding: 10px;
        padding-right: 0px;

    }

    .box_modal_nurse {
        position: fixed;
        display: block;
        /*width: 440px;
        height: 350px;*/
        top:20%;
        left:50%;
        margin-top:-75px;
        margin-left:-150px;
        background:#d9e5e9;
        border:1px solid #386980;
        overflow:hidden;
        /* 아래 부분은 애니메이션 효과를 위한 부분 */
        visibility: collapse;
        filter: alpha(opacity=60);
        -webkit-transition: all .2s ease;
        transition: all .2s ease;
        -webkit-transform: scale(0, 0);
        -ms-transform: scale(0, 0);
        transform: scale(0, 0);
    }
    .sms-send-box {
        width: 500px;
    }

    .box_modal:hover{
        opacity: 1;
        filter: alpha(opacity=100);
    }

    .box_modal_template:hover{
        opacity: 1;
        filter: alpha(opacity=100);
    }

    /* 닫기 버튼으로 사용할 라벨 */
    .closer {
        position:absolute;
        width:30px;
        height:30px;
        top:0;
        z-index: 1;
        right:0;
        background:#eee;
        border-left:1px solid #386980;
        border-bottom:1px solid #386980;
        text-align:center;
        line-height:26px;
        font-size:16x;
        cursor:pointer;
    }
    .text {
        display:inline-block;
        padding:20px;
    }
    .text h3 {
        font-size:19px;
        margin:0;
    }
    .text p {
        font-size:13px;
    }
    .title_body {
        padding:0px;
    }

    /* 모달 윈도우가 팝업되는 코어 소스 */
    input.modal_nurse[type=checkbox]:checked ~ .box_modal_nurse {
        visibility: visible;
        -webkit-transform: scale(1, 1);
        -ms-transform: scale(1, 1);
        transform: scale(1, 1);
        z-index: 10;
    }
    .textAreaCustom {
        line-height: 4.8;
    }
    .sms-send-box{width:500px;margin:0 auto;padding:5px;border:1px solid #ccc;background:#f7f7f7;text-align:center}
    .sms-send-box h3{margin-bottom:5px}
    .sms-send-box textarea{width:90%}
    .sms-send-box p{display:block;width:90%;margin:0 auto;text-align:right}
    .btn_set.small{padding:3px 10px}
    .btn_set.mini{height:18px;padding:0 5px;font-size:11px}
    .btn_set.mid{padding:5px 5px;font-size:13px}
    .btn_set.med{padding:4px 0}
    .btn_set.large {
        min-width: 164px;
        font-size: 14px;
        font-weight: bold;
        padding: 2px 90px;
    }
    .btn_set.str_org{border:1px solid #f47a21;background-color:#f47a21;color:#fff}

    .table01 td h5{margin:5px 0 10px; font-size: 14px;}
    .table01{max-width:450px;border-collapse:collapse;border-top:2px solid #1b1b1b}
    .table01 th,.table01 td{position: relative; text-align:center}
    .table01 th{padding:5px;/* height:37px; */background:#f7f7f7; border:1px solid #ccc; color:#000;background-clip: padding-box;}
    .table01 td{padding:5px;border:1px solid #e1e1e1;line-height:20px; vertical-align: middle;}
    table01 td a{text-decoration:underline}
    .table01.soft tr th:first-child{border-left:1px solid #e1e1e1}
    .table01.soft td.nobr{border-right:0}
    .table01.soft th{padding-right:0;border-color:#e1e1e1;border-left:0;font-weight:normal}
    .table01.soft td{padding-right:0}
    .table01.horiz_soft th{font-weight:normal}
    .table01.horiz_soft td{padding:0}
    .table01 .scope_td_col strong{display:inline-block;padding-right:50px;line-height:normal;vertical-align:middle;word-break:break-word}
    .table01 .scope_td_col .crm{position:absolute;top:0;right:0}
    .table01 .scope_td_col .btn_set.mini{padding:0 2px;line-height:18px}
    .table01 .scope_td_col .btn_set em{font-size:10px}
    .table01.tbl_list tr.hover td,.table01.tbl_list tr:hover td{background-color:#ffc}
    .table01 input[type=text],.table01 input[type=password],input.int{padding:5px;border:1px solid #ddd;font-size:13px;color:#000}
    .table01 label{display:inline-block;padding:0 15px 0 0;line-height:30px;vertical-align:middle}
    .table01.table_row th{padding-left:15px;color:#555}
    .table01.table_row th,.table01.table_row td{padding-left:10px;text-align:left}
    .table01.table_row th input[type=checkbox],.table01.table_row td input[type=checkbox]{margin:0;}
    .btn_set.brcrgray{border:1px solid #d3d3d3;color:#555}
    .btn_set.brcrred,.btn_set.brcrorg{border:1px solid #ff7019;background-color:#fff;color:#ff7019}
    .table01 th {
        color: rgb(0, 0, 0);
        padding: 5px;
        background: padding-box rgb(247, 247, 247);
        border-width: 1px;
        border-style: solid;
        border-color: rgb(204, 204, 204);
        border-image: initial;
    }
    .hidden {
        display:none;
        visibility:hidden;
    }

</style>
<template>
    <div>
        <CCard>
            <CCardHeader>
                <CIcon name="cil-justify-center"/> <strong> 간병인 내역 </strong>
                <small></small>
            </CCardHeader>
            <CCardBody class="title_body">
                <CNavbar light color="light">
                    <CForm inline>
                       <!-- <div role="group" class="form-group form-row" style="margin-right: 10px;">
                            <div class="col-sm-9 input-group-sm">
                                <el-date-picker
                                        size="sm"
                                        v-model="monthVal"
                                        type="month"
                                        placeholder="월을 선택하세요"
                                        @click="searchList"
                                >
                                </el-date-picker>
                            </div>
                        </div>-->
                       <!-- <div role="group" class="form-group form-row" style="margin-right: 10px;">
                            <div class="col-sm-9 input-group-sm">
                                <input id="uid-dq9zl88hwf8" type="date"  class="form-control" v-model="startMonthVal" min="2000-01-02" max="2999-12-31" >
                            </div>
                        </div>
                        <div role="group" class="form-group form-row" style="margin-right: 10px;">
                            <div class="col-sm-9 input-group-sm">
                                <input id="uid-dq9zl88hwf8" type="date"  class="form-control" v-model="endMonthVal" min="2000-01-02" max="2999-12-31" >
                            </div>
                        </div>-->
                        <div role="group" class="form-group form-row">
                            <div class="col-sm-9 input-group-sm">
                                <CInput
                                        class="mr-sm-2"
                                        placeholder="이름"
                                        size="sm"
                                        v-model="searchVal"
                                        @keyup.enter="searchList"
                                />
                            </div>
                        </div>
                        <CButton color="outline-success" size="sm" class="my-2 my-sm-0" type="button" @click="searchList">검색</CButton>
                    </CForm>
                </CNavbar>
            </CCardBody>
        </CCard>
        <CRow>
            <div class="col-sm-12" style="margin-bottom: 10px;">
                <div class="col-sm-0.5">
                    <li class="bottom_btn_custom">
                        <div class="d-inline-block dropdown">
                            <select id="uid-utosbj1koo"  v-model="selectOption"  @change="selectPerPage" class="form-control">
                                <option value="10" selected>10개씩보기</option>
                                <option value="20">20개씩보기</option>
                                <option value="I50">50개씩보기</option>
                            </select>
                        </div>
                    </li>
                  <!--  <li class="bottom_btn_custom" style="float: right;">
                        <CButton label=""
                                 type="button"
                                 style="text-align: right"
                                 class="btn btn-info " @click="goExcelDownload">엑셀 다운로드
                        </CButton>
                    </li>-->
                </div>
            </div>

        </CRow>
        <CRow>
            <CCol sm="12">
                <div bordered="true" small="true">
                    <div class="position-relative table-responsive">
                        <b-table
                                id = "list-table"
                                :items="newItems"
                                :fields="fields"
                                :per-page="perPage"
                                :current-page="currentPage"
                                @row-clicked="selNurse"
                                striped hover
                        >
                            <template v-slot:cell(id)="data">
                                <b  class="text-right">{{data.item.id }}</b>
                            </template>
                            <template v-slot:cell(amount)="data">
                                <div  class="text-right">{{data.item.amount }}</div>
                            </template>
                        </b-table>

                    </div>
                    <!--<div style="float:right;">총합계  요청건수: {{chargeCnt}} / 청구금액: {{totalChargeAmount | comma}} 원 </div>-->
                  <!--  <div id="tje5Special">
                        <ul class="cf">
                            <li style="width: 220px;">
                                <p>청구금액: {{totalChargeAmount | comma}} 원</p>
                            </li>
                            <li>
                                <p>요청건수: {{chargeCnt}} 건</p>
                            </li>
                        </ul>
                    </div>-->
                    <b-pagination
                            :link-gen="linkGen"
                            :number-of-pages="10"
                            use-router
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="list-table"
                    />
                </div>
            </CCol>
        </CRow>
        <input type="checkbox" id="modal_nurse" class="hidden modal_nurse">
        <div class="box_modal_nurse">
            <label for="modal_nurse" class="closer">x</label>
            <div class="text">
                <table>
                    <tr>
                        <td>
                            <div class="sms-send-box">
                                <CCard>
                                    <CCardHeader>
                                        <strong>간병인 정보 수정</strong>
                                    </CCardHeader>
                                    <CCardBody>
                                        <CForm>
                                            <CInput
                                                    label=""
                                                    placeholder="간병인 이름을 입력해주세요"
                                                    horizontal
                                                    required
                                                    was-validated
                                                    v-model="nurseId"
                                                    maxlength="100"
                                                    readonly
                                                    hidden
                                            />
                                            <CInput
                                                    label="간병인 이름"
                                                    placeholder="간병인 이름을 입력해주세요"
                                                    horizontal
                                                    required
                                                    was-validated
                                                    v-model="name"
                                                    maxlength="10"
                                            />
                                            <CInput
                                                    label="주민번호(6자리)"
                                                    placeholder="주민번호(6자리)"
                                                    horizontal
                                                    required
                                                    was-validated
                                                    v-model="citizenNo"
                                                    maxlength="6"
                                            />
                                            <CInput
                                                    label="연락처"
                                                    placeholder="연락처를 입력해주세요"
                                                    horizontal
                                                    required
                                                    was-validated
                                                    v-model="phone"
                                                    maxlength="20"
                                            />
                                            <CInput
                                                    label="이메일"
                                                    placeholder="이메일을 입력해주세요"
                                                    horizontal
                                                    required
                                                    was-validated
                                                    v-model="email"
                                                    maxlength="100"
                                            />
                                            <CInput
                                                    label="메모"
                                                    placeholder="메모를 입력해주세요"
                                                    horizontal
                                                    required
                                                    was-validated
                                                    v-model="memo"
                                                    maxlength="100"
                                            />
                                            <!--<datetime type="datetime" v-model="datetime12" use12-hour></datetime>-->
                                        </CForm>
                                    </CCardBody>
                                    <CCardFooter>
                                        <div style="float: left;">
                                            <CButton type="button" size="sm" color="primary"  @click="saveNurse" ><CIcon name="cil-check-circle"/> 저장</CButton>
                                        </div>
                                    </CCardFooter>
                                </CCard>
                            </div>
                        </td>
                    </tr>
                </table>
                <!-- <CButton label=""
                           type="button"
                           style="text-align: center"
                           class="btn_set str_org mid" @click="saveTemplate">
                      내용 저장
                  </CButton>-->
            </div>
        </div>
    </div>
</template>
<style>
    .btn-col-margin{
        margin-top: 5px;
        margin-left: 15px;
        margin-right: 10px;
    }
</style>
<script>
    import axios from "axios"
    import Vue from 'vue';
    import DatePicker from 'element-ui';
    import 'element-ui/lib/theme-chalk/index.css';
    import lang from 'element-ui/lib/locale/lang/ko'
    import locale from 'element-ui/lib/locale'
    import VueMoment from 'vue-moment'

    Vue.use(VueMoment)

    // configure language
    locale.use(lang)

    Vue.use(DatePicker);

    export default {
        name: 'app',
        components: {},
        data () {
            return {
                items: [],
                selectOption :10,
                searchVal: null,
                /*monthVal: '',*/
                newItems: [],
                perPage: 10,
                currentPage: 1,
                chargeCnt:0,
                memo:"",
                email:"",
                phone:"",
                citizenNo:"",
                nurseId:"",
                name:"",
                startMonthVal:  this.$moment().add(-30,'d') .format('YYYY-MM-DD'),
                endMonthVal: this.$moment().format('YYYY-MM-DD'),
                totalChargeAmount:0,
                fields: [
                    {
                        key: 'nurseId',
                        label: 'No',
                        class:'width_set_no',
                        sortable: true
                    },
                    {
                        key: 'citizenNo',
                        label: '주민번호',
                        class:'width_set_nine',
                        sortable: true
                    },
                    {
                        key: 'name',
                        label: '이름',
                        class:'width_set_nine',
                        sortable: true
                    },
                    {
                        key: 'phone',
                        label: '연락처',
                        class:'width_set_nine',
                        sortable: true
                    },
                    {
                        key: 'email',
                        label: '이메일',
                        class:'width_set_nine',
                        sortable: true
                    },
                    {
                        key: 'enabledYn',
                        label: '활성화여부',
                        class:'width_set_nine',
                        sortable: true
                    },
                    {
                        key: 'insertTime',
                        class:'insertTime',
                        label: '등록일',
                        sortable: true
                    }
                ]
            }
        },
        computed: {
            rows() {
                return this.items.length;
            }
        },
        filters:{
            comma(val){
                return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
        },
        mounted () {
            this.searchList();
        },

        methods: {
            searchList(){
                const qs = require('qs');
                const formData = qs.stringify({'startMonthVal': this.startMonthVal, 'endMonthVal':this.endMonthVal, 'searchVal': this.searchVal})
                axios.post('silver/nurse/getNurseList', formData)
                    .then(res => {
                        this.newItems=[]
                        console.log("===================");
                        console.log(res.data);
                        console.log("===================");
                        this.items = res.data;
                        for(var i = 0; i < this.items.length; i++){
                            const obj = new Object();
                            obj.nurseId = this.items[i].nurseId;

                            if(this.items[i].insertTime == null || this.items[i].insertTime == "") {
                                obj.insertTime = "";
                            } else {
                                obj.insertTime = this.$moment(this.items[i].insertTime).format('YYYY-MM-DD');
                            }

                            obj.citizenNo = this.items[i].citizenNo;
                            obj.name = this.items[i].name;
                            obj.email = this.items[i].email;
                            obj.phone = this.items[i].phone;
                            obj.enabledYn = this.items[i].enabledYn;

                            if(this.items[i].enabledYn == 'Y') {
                                obj.enabledYn = "활성화";
                            } else if(this.items[i].enabledYn == 'N'){
                                obj.enabledYn = "비활성화";
                            }

                            obj.memo = this.items[i].memo;

                            this.newItems.push(obj);
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
                axios.post('silver/charge/getChargeListCnt', formData)
                    .then(res => {
                        this.chargeCnt = res.data.chargeCnt;
                        this.totalChargeAmount = res.data.totalChargeAmount;
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            }
            , selectPerPage () {
                this.perPage =  this.selectOption;
            },
            linkGen(pageNum) {
                return pageNum === 1 ? '?' : `?page=${pageNum}`
            },
            comma(val){
                return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
            selNurse(record, index) {
                var modal_nurse = document.getElementById( 'modal_nurse' );

                this.name = "";
                this.nurseId = "";
                this.memo = "";
                this.citizenNo = "";
                this.phone = "";
                this.email = "";
                modal_nurse.click();
                /*$(".modal_nurse").click();*/
                const qs = require('qs');
                const formData = qs.stringify({'nurseId': record.nurseId});
                axios.post('silver/nurse/getNurse', formData)
                    .then(res => {
                        this.nurseId = res.data.nurseId;
                        this.name = res.data.name;
                        this.memo = res.data.memo;
                        this.citizenNo = res.data.citizenNo;
                        this.phone= res.data.phone;
                        this.email = res.data.email;
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            },
            saveNurse() {
                var modal_nurse = document.getElementById( 'modal_nurse' );
                axios.post('silver/nurse/upNurse', {
                    nurseId: this.nurseId,
                    name: this.name,
                    memo: this.memo,
                    citizenNo: this.citizenNo,
                    phone: this.phone,
                    email: this.email
                })
                    .then(res => {
                        this.name = res.data.name;
                        this.memo = res.data.memo;
                        this.citizenNo = res.data.citizenNo;
                        this.phone= res.data.phone;
                        this.email = res.data.email;
                        alert("저장되었습니다.");
                        modal_nurse.click();
                        this.searchList();

                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            },
            goExcelDownload() {
                const qs = require('querystring');
                const formData = qs.stringify({
                    'startMonthVal': this.startMonthVal,
                    'endMonthVal':this.endMonthVal,
                    'searchVal': this.searchVal
                });

                axios.post('silver/charge/getChargeListExcel', formData, {
                    responseType: "blob",
                }).then(res => {
                    try {
                        let blob = new Blob([res.data], { type: res.headers['content-type'] });
                        //let fileName = this.getFileName(res.headers['content-disposition']);


                        //파일명 인코딩 문제로 직업 삽입
                        let fileName = "청구내역리스트.xlsx";
                        // fileName = decodeURI(fileName); // 파일명 디코딩 (프로젝트에 따라 사용여부 옵션)

                        if (window.navigator.msSaveOrOpenBlob) { // IE 10+
                            window.navigator.msSaveOrOpenBlob(blob, fileName)
                        } else { // not IE
                            let link = document.createElement('a');
                            link.href = window.URL.createObjectURL(blob);
                            link.target = '_self';
                            if (fileName) link.download = fileName;
                            link.click();
                            link.remove();
                        }
                    } catch (e) {
                        console.error(e)
                    }
                }).catch(error => {
                    console.log(error);
                });
            } , getFileName (contentDisposition) {
                let fileName = contentDisposition
                    .split(';')
                    .filter((ele) => {
                        return ele.toLowerCase().indexOf('filename') > -1
                    })
                    .map((ele) => {
                        return ele
                            .replace(/"/g, '')
                            .split('=')[1]
                    });
                return fileName[0] ? fileName[0] : null
            }
        }

    }
</script>
